export default class Drawer {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    const boutton = document.querySelector('.voir_plus');
    boutton.addEventListener('click', this.openDescription.bind(this));
  }

  openDescription(event) {
    event.currentTarget.classList.toggle('is-active');
  }
}
